import angular from 'angular';
import APIV5 from '~/models/api';

class MailService {
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;
		this.$timeout = $injector.get('$timeout');
		this.$translate = $injector.get('$translate');
		this.Notification = $injector.get('Notification');
	}

	/**
	 * @param {any} mail
	 * @returns {Promise<any>}
	 */
	async send(mail) {
		const temporary = document.createElement('DIV');
		temporary.innerHTML = mail.body;
		mail.body_alt = temporary.textContent || temporary.textContent;

		// remove empty email from recipient list
		mail.list = mail.list.filter(
			(/** @type {any} */ element) => element.email || element.name?.isa === 'K_NODE;MAILINGLIST'
				|| element.person?.isa === 'K_NODE;MAILINGLIST'
				|| element.type === 'link_knode',
		).map(
			(/** @type {any} */ element) => {
				/** @type {any} */
				const item = {
					type: element.type,
					kid:  element.kid,
					name: element.name,
				};
				if (element.email?.kid) {
					item.email = element.email.name;
				}
				if (element.name?.kid) {
					item.kid = element.name.kid;
					item.name = element.name.name;
				}
				if (element.person?.kid) {
					item.kid = element.person.kid;
					item.name = element.person.name;
				}
				return item;
			},
		);

		await APIV5.instance.emailCreate({
			list:      mail.list,
			body:      mail.body,
			body_alt:  mail.body_alt,
			subject:   mail.subject,
			code_type: mail.code_type,
		}, { id: 'mail-service.send' });
		this.$timeout(() => {
			this.Notification.success({
				title:     this.$translate.instant('common.info'),
				message:   this.$translate.instant('mail.success-sent-message'),
			});
		});
	}
}

const mailService = /* @ngInject */ (
	/** @type {import('angular').auto.IInjectorService} */ $injector,
) => new MailService($injector);

export default angular.module('app')
	.factory('MailService', mailService);
